import { Badge, Stack } from '@mantine/core'
import { countBy } from 'lodash-es'
import { FormattedMessage, useIntl } from 'react-intl'
import { Gpu } from '@/types/device'

type GpuBadgeListProps = {
  gpus: Gpu[]
  isJetson?: boolean
}

export const GpuBadgeList = ({ gpus, isJetson }: GpuBadgeListProps) => {
  const intl = useIntl()

  if (isJetson) {
    return (
      <Badge size="sm" color="gray.6" variant="light">
        <FormattedMessage id="devices.gpu.integrated" />
      </Badge>
    )
  }

  if (gpus.length === 0) {
    return null
  }

  // group duplicates into "2 x Name" badges, one per unique GPU model
  const grouped = Object.entries(
    countBy(
      gpus,
      (gpu) =>
        gpu.name ??
        intl.formatMessage(
          { id: 'devices.gpu.indexLabel' },
          { index: gpu.index }
        )
    )
  )

  return (
    <Stack gap={4}>
      {grouped.map(([name, count]) => (
        <Badge key={name} size="sm" color="gray.6" variant="outline">
          {count > 1 ? `${count} x ${name}` : name}
        </Badge>
      ))}
    </Stack>
  )
}
